import { FC } from 'react';
import { IconPath, IconSVG, IconSVGComponentProps } from '../IconComponent';

export const FemaleSign: FC<IconSVGComponentProps> = ({
    pathProps,
    ...props
}) => {
    return (
        <IconSVG {...props}>
            <IconPath
                d="M12 13.294c3.314 0 6-2.528 6-5.647S15.314 2 12 2 6 4.528 6 7.647s2.686 5.647 6 5.647Zm0 0v4.353M12 22v-4.353m0 0h4.8-9.6"
                {...pathProps}
            />
        </IconSVG>
    );
};
